import React from 'react'
import RTable from 'react-table'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { compose, lifecycle, withState } from 'recompose'
import { reduxForm, getFormValues, FieldArray, Field } from 'redux-form'
import { Card, CardContent, Collapse, CardHeader, CircularProgress, Fade } from '@material-ui/core'
import ItemModal from './AddItemModal' 
import { BottomActionsContainer } from '../styled'
import { getMappingWbsAssets } from 'ducks/mappingData'
import { SelectItemsContainer, BudgetContainer } from './styled'
import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { costCenterColumn, wbsColumn, internalOrderColumn, itemColumns } from '../data'
import { showPrItemModal, validateBudget, getAttachmentTypes, selectSubCategory } from 'ducks/purchaseRequisition'
import { getOptionTitle, calculateTotalAmount, calculateVat, calculateTotalIncludeVat } from '../../helper'
import { getWbsElements, getCostCenter, getOrders, getPurchasingGroups, 
  getGlAccounts, getPurchasingOrgs, getMaterials } from 'ducks/options'

// import r from 'reactotron-react-js'

const itemFormToBudgetFormat = (item) => {
  return ({
    accountAssignmentCategoryCode: item.accountAssignment,
    glAccountCode: item.glAccountCode ? item.glAccountCode.padStart(10, '0') : '',
    wbsElementCode: item.wbsElement,
    orderTypeCode: item.orderType,
    orderCode: item.orderNo,
    costCenterCode: item.costCenter ? item.costCenter.padStart(10, '0') : '',
    coAreaCode: item.controllingArea,
    salesOrder: item.sellOrder,
    totalAmountEstimated: Number(item.totalAmount),
  })
}

export const summaryDataForCheckBudget = (valueForm) => {
  const { companyCode, items, documentDate } = valueForm
  let result = {
    year: (documentDate || new Date()).getFullYear(),
    companyCode: companyCode,
    lines: [],
  }

  items.forEach(item => {
    let aa = item.accountAssignment
    if (result.lines.length === 0) {
      let newItem = itemFormToBudgetFormat(item)

      if (aa === 'A' || aa === 'P' || aa === 'R' || aa === 'W') { // work around for ignore service bug
        newItem.coAreaCode = ''
      }

      result.lines.push(newItem)
    } else {
      
      let itemLine = undefined
      if (aa === 'K' || aa === 'Z') {
        itemLine = result.lines.find(i => i.glAccountCode === item.glAccountCode.padStart(10, '0') && 
                                          i.costCenterCode === item.costCenter.padStart(10, '0'))
        if (itemLine) {
          itemLine.totalAmountEstimated = Number(itemLine.totalAmountEstimated) + Number(item.totalAmount)
        } else {
          result.lines.push(itemFormToBudgetFormat(item))
        }
      } else if (aa === 'F') {
        itemLine = result.lines.find(i => i.glAccountCode === item.glAccountCode.padStart(10, '0') && 
                                          i.orderCode === item.orderNo && 
                                          i.orderTypeCode === item.orderType)
        if (itemLine) {
          itemLine.totalAmountEstimated = Number(itemLine.totalAmountEstimated) + Number(item.totalAmount)
        } else {
          result.lines.push(itemFormToBudgetFormat(item))
        }
      } else if (aa === 'A' || aa === 'P' || aa === 'R' || aa === 'W') {
        itemLine = result.lines.find(i => i.wbsElementCode === item.wbsElement)
        if (itemLine) {
          itemLine.totalAmountEstimated = Number(itemLine.totalAmountEstimated) + Number(item.totalAmount)
        } else {
          let wbsItem = itemFormToBudgetFormat(item)
          wbsItem.coAreaCode = '' // work around for ignore service bug
          result.lines.push(wbsItem)
        }
      }
    }
  })

  return result
}

export const onValidateBudgetSuccess = (props) => (budgetData) => {
  const { newRawData, change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions } = props
  let result = {
    costCenter: [],
    wbs: [],
    internalOrder: [],
  }

  // r.log({ newRawData, change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions })

  // Cost Center
  let listCostCenter = newRawData.lines.filter(b => b.accountAssignmentCategoryCode === 'K' || b.accountAssignmentCategoryCode === 'Z') || undefined
  if (listCostCenter) {
    listCostCenter.forEach(c => {
      const costCenter = c.costCenterCode.removeLeadingZero()
      const glAccount = c.glAccountCode.removeLeadingZero()
      let budgets = budgetData.find(
        b => b.code.removeLeadingZero() === costCenter.removeLeadingZero() && 
        b.code2.removeLeadingZero() === glAccount.removeLeadingZero())
      if (budgets) {
        result.costCenter.push(budgets)
      } else {
        result.costCenter.push({
          code: costCenter, 
          description: getOptionTitle(costCenterOptions, costCenter, false),
          code2: glAccount, 
          description2: getOptionTitle(glAccountOptions, glAccount, false),
          plan: null, assigned: 0, available: 0, currencyCode: 'THB',
        })
      }
    })
  }

  //Internal Order
  let listOrder = newRawData.lines.filter(b => b.accountAssignmentCategoryCode === 'F') || undefined
  if (listOrder) {
    listOrder.forEach(o => {
      let budgets = budgetData.find(
        b => b.code.removeLeadingZero() === o.orderCode.removeLeadingZero() && 
             b.code2.removeLeadingZero() === o.glAccountCode.removeLeadingZero())
      if (budgets) {
        budgets.code = budgets.code.removeLeadingZero()
        result.internalOrder.push(budgets)
      } else {
        const glAccount = o.glAccountCode.removeLeadingZero()
        const orderCode = o.orderCode.removeLeadingZero()
        result.internalOrder.push({
          code: orderCode, 
          description: getOptionTitle(orderOptions, o.orderCode, false),
          code2: glAccount, 
          description2: getOptionTitle(glAccountOptions, glAccount, false),
          plan: null, assigned: 0, available: 0, currencyCode: 'THB',
        })
      }
    })
  }

  // WBS
  let listWbs = newRawData.lines.filter(b => b.accountAssignmentCategoryCode === 'A' ||
                                                b.accountAssignmentCategoryCode === 'P' ||
                                                b.accountAssignmentCategoryCode === 'R' ||
                                                b.accountAssignmentCategoryCode === 'W') || undefined
  if (listWbs) {
    listWbs.forEach(w => {
      let budgets = budgetData.find(b => b.wbsElementNo === w.wbsElementCode)
      if (budgets) {
        let wbsResult = checkLevelBudget(budgets, budgetData).reverse()
        wbsResult.forEach(wr => {
          if (!result.wbs.find(i => i.wbsElementNo === wr.wbsElementNo)) {
            result.wbs.push(wr)
          }
        })

        result.wbs.sort(function(a, b) {
          if(a.code < b.code) { return -1 }
          if(a.code > b.code) { return 1 }
          return 0
        })
      } else {
        result.wbs.push({
          code: w.wbsElementCode, 
          description: getOptionTitle(wbsOptions, w.wbsElementCode, false),
          code2: '', description2: '',
          plan: null, assigned: 0, available: 0, currencyCode: 'THB',
        })
      }
    })
  }

  change('budgetData', result)
}

const checkLevelBudget = (current, list, result = []) => {
  if (!current) {
    return result
  }

  let next = {}
  if (result.length === 0) {
    result.push(current)
    next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
    return checkLevelBudget(next, list, result)
  } else if (result.length === 1) {
    if (current.wbsControlBudget === '') { //End of line
      result.push(current)
      return result
    }

    if (current.plan !== 0) {
      result.push(current)
      next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
      return checkLevelBudget(next, list, result)
    } else {
      next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
      return checkLevelBudget(next, list, result)
    }
  } else if (result.length === 2) {
    if (current.wbsControlBudget === '') { //End of line
      result.push(current)
      return result
    } else {
      next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
      return checkLevelBudget(next, list, result)
    }
  } else {
    return result
  }
}

const onSubmitItem = (items, change) => (fields) => (data) => {
  fields.push(data)

  if (items) {
    if (items.length === 0) {
      change('vatRate', data.currency === 'THB' ? 7 : 0)
    }
  } else {
    change('vatRate', 7)
  }
}

const editPrItem = (items) => (index, change) => (data) => {
  change(`items[${index}]`, data)

  if (items) {
    if (items.length === 1) {
      change('vatRate', data.currency === 'THB' ? 7 : 0)
    }
  } else {
    change('vatRate', 7)
  }
}

const renderTableItems = (props) => {
  const { fields, recommendItems, change, items, showPrItemModal, assetOptions,
    budgetTypeOptions, unitOptions, currencyOptions, accountAssignmentOptions, 
    materialGroupOptions, plantOptions, storageLocationOptions, glAccountOptions,
    costCenterByRequester, menuSubCategory, purchasingGroupOptions, costCenterOptions,
    orderOptions, purchasingOrgOptions, profitCenterOptions, wbsOptions, vatRate,
    defaultCurrency } = props

  fields.map((field, index) => change(`${field}.lineNo`, index + 1))

  return (
    <SelectItemsContainer>
      <Card>
        <CardHeader 
          title='Items'
          action={
            <div className='cardHeaderActions'>
              <Button type='button' className='hiddenButton' circular icon='chevron up' />
            </div>
          }
        />
        <CardContent>
          <div className='tableContainer'>
            <RTable
              minRows={5}
              className='prItems'
              sortable={false}
              columns={
                itemColumns({ 
                  withActions: true, fields, items, change, showPrItemModal, 
                  budgetTypeOptions, assetOptions, unitOptions, currencyOptions, 
                  accountAssignmentOptions, materialGroupOptions, wbsOptions,
                  plantOptions, storageLocationOptions, costCenterByRequester, 
                  menuSubCategory, purchasingGroupOptions, glAccountOptions, costCenterOptions, 
                  editPrItem: editPrItem(items), onSubmitItem: onSubmitItem(items, change), orderOptions, purchasingOrgOptions, profitCenterOptions,
                  defaultCurrency
                })} 
              data={items}
            />
            <div className='totalContent'>
              <span className='labelText'>Total Amount</span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {calculateTotalAmount(items, change)}
                <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${defaultCurrency}`}</span>
              </div>
            </div>
            <div className='totalContent'>
              <div style={{ width: 'auto', display: 'flex', flexDirection: 'row' }}>
                <span className='labelText'>VAT</span>
                <Field 
                  name='vatRate' 
                  containerStyle={{ marginRight: '0px' }} 
                  suffix='%' 
                  marginLess
                  type={type.number} 
                  allowNegative={false} 
                  component={FieldInput} />
                <div style={{  display: 'flex', alignItems: 'center', marginRight: '0px', marginLeft: '15px' }}>
                  {calculateVat(items, vatRate, change)}
                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${defaultCurrency}`}</span>
                </div>
              </div>
            </div>
            <div className='totalContent'>
              <span className='labelText'>Net Amount</span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {calculateTotalIncludeVat(items, vatRate, change)}
                <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${defaultCurrency}`}</span>
              </div>
            </div>
          </div>
          {
            recommendItems && recommendItems.length > 0 ? 
            <div className='recommendItemContainer'>
              <span className='sectionTitle'>
                Recommend Items
              </span>
              {recommendItems.map(i => 
                <Card 
                  key={i.itemName}
                  style={{ cursor: 'pointer', marginTop: '8px' }} 
                  onClick={() => {
                    const newItem = { 
                      itemName: i.itemName, 
                      menuSubCategory,
                      quantity: 0, 
                      unit: '', 
                      unitPrice: 0, 
                      totalAmount: 0,
                      currency: defaultCurrency,
                      costCenter: costCenterByRequester
                    }
                    showPrItemModal(true, true, newItem, onSubmitItem(items, change)(fields))
                  }}
                >
                  <CardContent style={{ padding: '8px' }}>
                    <span className='itemTitle'>
                      {i.itemName}
                    </span>
                  </CardContent>
                </Card> 
              )}
            </div> : null
          }
        </CardContent>  
      </Card>
    </SelectItemsContainer>
  )
}

const SelectPrItems = (props) => {
  const { valueForm, change, handleSubmit, recommendItems, showPrItemModal, 
    subCategory, setFormStep, showModal, showBudgets, setShowBudgets, validatingBudget } = props
  
  const costCenterByRequester = valueForm && valueForm.costCenterByRequester ? valueForm.costCenterByRequester : ''
  const recItems = valueForm && valueForm.menuSubCategory ?
                   recommendItems.filter(i => i.subCategoryCode === valueForm.menuSubCategory) : []
  const items = valueForm ? valueForm.items ? valueForm.items : [] : []
  const budgetData = valueForm && valueForm.budgetData ? valueForm.budgetData : { costCenter: [], wbs: [], internalOrder: [] }

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <form className='ui form' onSubmit={handleSubmit}>
          <FieldArray
            name='items'
            items={items}
            change={change}
            showPrItemModal={showPrItemModal}
            accountAssignmentOptions={props.accountAssignmentOptions}
            assetOptions={props.assetOptions}
            budgetTypeOptions={props.budgetTypeOptions}
            costCenterOptions={props.costCenterOptions}
            costCenterByRequester={costCenterByRequester}
            currencyOptions={props.currencyOptions}
            defaultCurrency={props.defaultCurrency}
            glAccountOptions={props.glAccountOptions}
            menuSubCategory={valueForm.menuSubCategory}
            materialGroupOptions={props.materialGroupOptions}
            orderOptions={props.orderOptions}
            plantOptions={props.plantOptions}
            profitCenterOptions={props.profitCenterOptions}
            purchasingGroupOptions={props.purchasingGroupOptions}
            purchasingOrgOptions={props.purchasingOrgOptions}
            recommendItems={recItems}
            storageLocationOptions={props.storageLocationOptions}
            unitOptions={props.unitOptions}
            wbsOptions={props.wbsOptions}
            vatRate={valueForm.vatRate}
            component={renderTableItems} />
          {
            (budgetData.costCenter.length > 0 || 
              budgetData.wbs.length > 0 || 
              budgetData.internalOrder.length > 0) ?
              <BudgetContainer>
                <Card>
                  <CardHeader 
                    title={
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <span className='MuiTypography-root MuiCardHeader-title MuiTypography-h5 MuiTypography-displayBlock' style={{ marginRight: '10px' }}>Budget Information</span>
                        {validatingBudget ? <CircularProgress size={20} color='primary' /> : null}
                      </div>
                    }
                    action={
                      <div className='cardHeaderActions'>
                        {showBudgets ? 
                          <Button type='button' circular icon='chevron up' onClick={() => setShowBudgets(false)} /> : 
                          <Button type='button' circular icon='chevron down' onClick={() => setShowBudgets(true)} />}
                      </div>
                    }
                  />
                  <Collapse in={showBudgets}>
                    <CardContent>
                      <div>
                        {
                          budgetData.costCenter.length > 0 ?
                          <div className='budgetTable'>
                            <span className='tableTitle'>Cost Center</span>
                            <RTable
                              className='budgets'
                              columns={costCenterColumn}
                              data={budgetData.costCenter}
                              minRows={budgetData.costCenter.length || 1}
                              showPagination={false}
                            />
                          </div> : null
                        }
                        {
                          budgetData.wbs.length > 0 ?
                          <div className='budgetTable'>
                            <span className='tableTitle'>Work Breakdown Structure (WBS)</span>
                            <RTable
                              className='budgets'
                              columns={wbsColumn}
                              data={budgetData.wbs}
                              minRows={budgetData.wbs.length || 1}
                              showPagination={false}
                            />
                          </div> : null
                        }
                        {
                          budgetData.internalOrder.length > 0 ?
                          <div className='budgetTable'>
                            <span className='tableTitle'>Internal Order</span>
                            <RTable
                              className='budgets'
                              columns={internalOrderColumn}
                              data={budgetData.internalOrder}
                              minRows={budgetData.internalOrder.length || 1}
                              showPagination={false}
                            />
                          </div> : null
                        }
                      </div>
                    </CardContent>
                  </Collapse>
                </Card>
              </BudgetContainer>
              : null
          }
          <BottomActionsContainer>
            <Button 
              type='button'
              content='Back'
              icon='arrow left' 
              labelPosition='left'
              color='red'
              onClick={() => setFormStep(2)} 
            /> 
            <Button 
              type='submit'
              content='Next' 
              color='blue' 
              icon='arrow right' 
              disabled={items.length === 0}
              labelPosition='right'
            />
          </BottomActionsContainer>
        </form>
        {showModal ? <ItemModal subCategory={subCategory} /> : null}
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state) => {
  let valueForm = getFormValues('formCreatePR')(state) || {}
  let subCategory = state.pr.subCategory
  let mappingPurchasingGroups = state.mappingData.purchasingGroups.data
  
  if (subCategory.purchasingGroup.length >= 1) {
    if (subCategory.purchasingGroup.length === 1) {
      valueForm.purchasingGroup = subCategory.purchasingGroup[0]
    } else {
      let purchasingGroupByCompany = mappingPurchasingGroups.find(m => m.companyCode === valueForm.companyCode)
      if (purchasingGroupByCompany) {
        subCategory.purchasingGroup.forEach(p => {
          let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
          if (match) {
            valueForm.purchasingGroup = match
          }
        })
      }
    }
  }

  let companyCode = valueForm.companyCode || ''
  let assetOptions = state.options.assets.data.filter(a => a.companyCode === companyCode)

  const orderOptions = state.options.orders.data.map(o => ({
    ...o,
    text: o.text.removeLeadingZero(),
  }))

  

  let defaultCurrency = (valueForm.items && valueForm.items.length > 0) ? valueForm.items[0].currency : 'THB'

  return ({
    initialValues: {
      ...valueForm,
      vatRate: valueForm.vatRate !== undefined ? valueForm.vatRate : 7
    },
    accountAssignmentOptions: state.options.accountAssignments.data,
    assetOptions,
    attachmentTypes: state.pr.attachmentTypes,
    budgetTypeOptions: state.options.budgetTypes.data,
    companyPlantMapping: state.mappingData.companyPlants.data,
    costCenterLoading: state.options.costCenters.loading,
    costCenterOptions: state.options.costCenters.data,
    currencyOptions: state.options.currencies.data,
    defaultCurrency,
    glAccountLoading: state.options.glAccounts.loading,
    glAccountOptions: state.options.glAccounts.data,
    mappingWbsAssets: state.mappingData.wbsAssets.data,
    materialGroupOptions: state.options.materialGroups.data,
    materialOptions: state.options.materials.data,
    orderOptions,
    plantOptions: state.options.plants.data,
    profitCenterOptions: state.options.profitCenters.data,
    purchasingOrgOptions: state.options.purchasingOrgs.data,
    purchasingGroupLoading: state.options.purchasingGroups.loading,
    purchasingGroupOptions: state.options.purchasingGroups.data,
    recommendItems: state.pr.recommendItems.data,
    showModal: state.pr.showPrItemModal,
    storageLocationOptions: state.options.storageLocations.data,
    unitOptions: state.options.units.data,
    wbsOptions: state.options.wbsElements.data,
    validatingBudget: state.pr.validatingBudget,
    valueForm,
  })
}

const mapDispatchToProps = {
  showPrItemModal,
  getWbsElements,
  getCostCenter,
  getOrders,
  validateBudget,
  getPurchasingGroups,
  getPurchasingOrgs,
  getGlAccounts,
  getAttachmentTypes,
  getMaterials,
  getMappingWbsAssets,
}

const enhance = compose(
  withState('showBudgets', 'setShowBudgets', true),
  withState('budgetRawData', 'setBudgetRawData', undefined),
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formCreatePR',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  lifecycle({
    componentDidMount() {
      const { wbsOptions, getWbsElements, valueForm: { companyCode }, 
      costCenterOptions, getCostCenter, orderOptions, getOrders,
      purchasingGroupOptions, getPurchasingGroups,
      glAccountOptions, getGlAccounts, attachmentTypes, getAttachmentTypes,
      purchasingOrgOptions, getPurchasingOrgs, 
      mappingWbsAssets, getMappingWbsAssets } = this.props

      if (!wbsOptions.length) {
        getWbsElements(companyCode)
      } else {
        if (wbsOptions[0].companyCode !== companyCode) {
          getWbsElements(companyCode)
        }
      }

      if (!costCenterOptions.length) {
        getCostCenter()
      }

      if (!orderOptions.length) {
        getOrders()
      }

      if (!purchasingGroupOptions.length) {
        getPurchasingGroups()
      }

      if (!glAccountOptions.length) {
        getGlAccounts()
      }

      if (!attachmentTypes.length) {
        getAttachmentTypes()
      }

      if (!purchasingOrgOptions.length) {
        getPurchasingOrgs()
      }

      if (!mappingWbsAssets.length) {
        getMappingWbsAssets()
      }

      const { valueForm: { menuSubCategory }, 
        companyPlantMapping, plantOptions, 
        materialOptions, getMaterials } = this.props
      
      if (menuSubCategory === 'G16-1') {
        const plantByCompany = companyPlantMapping.filter(cp => cp.companyCode === companyCode) || []
        let availablePlant = []
        if (plantByCompany) {
          availablePlant = plantOptions.filter(p => plantByCompany.find(b => b.plantCode === p.value) !== undefined)
        } else {
          availablePlant = plantOptions
        }

        if (availablePlant.length) {
          availablePlant.forEach(p => {
            if(!materialOptions[p.value]) {
              getMaterials(p.value)
            }
          })
        }
      }
    },
    componentDidUpdate(prevProps) {
      const { purchasingGroupOptions, purchasingGroupLoading, getPurchasingGroups,
        glAccountOptions, glAccountLoading, getGlAccounts,
        costCenterOptions, costCenterLoading, getCostCenter } = this.props
      
      if (!purchasingGroupOptions.length && !purchasingGroupLoading) {
        getPurchasingGroups()
      }

      if (!glAccountOptions.length && !glAccountLoading) {
        getGlAccounts()
      }

      if (!costCenterOptions.length && !costCenterLoading) {
        getCostCenter()
      }

      const newForm = this.props.valueForm || {}
      const oldForm = prevProps.valueForm|| {}

      if (oldForm.items !== newForm.items) {
        const oldRawData = summaryDataForCheckBudget(oldForm)
        const newRawData = summaryDataForCheckBudget(newForm)

        if (JSON.stringify(oldRawData) !== JSON.stringify(newRawData)) {
          const { change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions } = this.props
          this.props.setBudgetRawData(newRawData)
          this.props.validateBudget(newRawData, onValidateBudgetSuccess({newRawData, change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions}))
        }
      }

      if (this.props.valueForm.items.length === 0) {
        this.props.setMaxStep(3)
      }
    },
  })
)

export default enhance(SelectPrItems)
